const FeedRightContent = ({ image }: { image: string }) => {
  if (!image) {
    return null
  }

  return <img src={image} alt="feed right" className="h-[35px] w-[45px] rounded-[3px] object-cover" />
}

export default FeedRightContent
